import { useGraphQuery } from "@dashboard/library";
import { GetCustomSummaryResults } from "@/graphql/queries/GetCustomSummaryResults";

export const useGetCustomSummaryResults = (callId?: string | null) => {
  const result = useGraphQuery(GetCustomSummaryResults, {
    variables: { input: { callId: callId ?? "" } },
    skip: !callId,
    // The custom summary is one section of the Insights tab, and this hook also runs
    // in DataAccessLayer. A failure here must degrade to an empty section, not throw
    // and crash the whole page. [CI-6183]
    throwError: false,
  });

  const customSummaryResults = result.output?.getCustomSummaryResults;

  return {
    ...result,
    customSummaryResult:
      customSummaryResults?.__typename === "GetCustomSummaryResultsResult"
        ? customSummaryResults.items?.[0]
        : undefined,
  };
};
